// extracted by mini-css-extract-plugin
export default {"root":"xiv4lM"};